export default __webpack_public_path__ + "static/media/add.90d20c76.png";